import { render, staticRenderFns } from "./clientiDdt.vue?vue&type=template&id=980a4a34"
import script from "./clientiDdt.vue?vue&type=script&lang=js"
export * from "./clientiDdt.vue?vue&type=script&lang=js"
import style0 from "./clientiDdt.vue?vue&type=style&index=0&id=980a4a34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports